/**
 * Skeleton — Loading placeholder components
 *
 * SkeletonLine: A single shimmer bar (configurable width via className)
 * SkeletonCard: A card wrapper with shimmer content
 *
 * Used by all pages to replace "Loading..." text with visual placeholders.
 */
import React from 'react';

export function SkeletonLine({ className = '' }) {
  return <div className={`skeleton-line ${className}`} />;
}

export function SkeletonCard({ dark = false, children }) {
  return (
    <div className={`skeleton-card ${dark ? 'skeleton-card--dark' : ''}`}>
      {children}
    </div>
  );
}
